import { Star } from '@phosphor-icons/react';
import { Icon } from '../atoms/Icon';
import { cn } from '../lib/cn';
import { uiNumber, uiText } from '../i18n';

export interface PointsPillProps {
  points: number;
  /** Show a sign, e.g. "+5" on a task that earns points. */
  signed?: boolean;
  size?: 'md' | 'lg';
  /** Spoken unit: "Sterne" for kids, "Punkte" for teens and parents (see IA glossary). */
  unit?: string;
  className?: string;
}

export function PointsPill({ points, signed, size = 'md', unit, className }: PointsPillProps) {
  const value = `${signed && points > 0 ? '+' : ''}${uiNumber(points)}`;
  return (
    <span
      className={cn(
        'inline-flex items-center gap-gap-xs rounded-chip bg-reward-points-surface font-display font-bold text-text-primary tabular-nums',
        size === 'md' ? 'px-inset-xs py-1 text-sm' : 'px-inset-sm py-1 text-lg',
        className,
      )}
    >
      <Icon
        icon={Star}
        weight="fill"
        size={size === 'md' ? 'sm' : 'md'}
        className="text-reward-points-ink"
      />
      <span aria-hidden>{value}</span>
      <span className="sr-only">{`${value} ${unit ?? uiText().points}`}</span>
    </span>
  );
}
